<template>
  <div id="home_div">
  <v-container fluid>
    <v-layout column align-center>
      <img src="@/assets/logo_infilesign_color.png" class="mb-5">
      <HelloWorld quote="Firma Electrónica Digital Avanzada" author="Infile S.A" />
    </v-layout>
   
   <v-slide-y-transition mode="out-in">
     <v-row align="center" justify="center">
      <v-col cols="12" md="6">
        <p>&nbsp;</p>
        <v-btn rounded block color="#4DB0F6" large dark :to="{ name: 'documento', params: {opt: 'create'}}">
          <v-icon color="lighten-1">mdi-plus</v-icon>
          Seleccione el documento a firmar
        </v-btn>
        <p>&nbsp;</p>
        <v-alert
          border="top"
          colored-border
          type="warning"
          elevation="2"
        >
          <ul>
            <li>El nombre de los documentos no deben tener tilde ni caracteres especiales.</li>
            <li>Por el momento solo se permiten documentos con nombre de 50 caracteres.</li>
          </ul>
        </v-alert>

      </v-col>
    </v-row>         
    </v-slide-y-transition> 
 
  </v-container>
  </div>
</template>


<script>
  import HelloWorld from '@/components/HelloWorld.vue'; 

  export default {
    components: { 
      HelloWorld, 
    },
    data () {
      return {

      }
    },
    watch: {

    },
    mounted () {
      console.log("app.vue.home");
    },
    methods: {

    },
  }
</script>

